module.exports = __webpack_public_path__ + "img/啤酒.1212c82b.png";